import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dimensions, Switch, Text, TouchableOpacity, View } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import HeaderTabs from "../../components/HeaderTabs";
import NumberInput from "../../components/NumberInput";
import ScreenLoader from "../../components/ScreenLoader";
import TradeView from "../../components/TradeView";
import activesService from "../../services/activesService";
import balanceService from "../../services/balanceService";
import exchangeService from "../../services/exchangeService";
import { formatGPXBalance, maxDecimals } from "../../utils/formatNumber";
import styles from "./styles";
import { FormattedMessage, useIntl } from "react-intl";
import { If, Then, Else, When } from "react-if";
import AllOrdersCard from "../../components/AllOrdersCard";
import ExchangeNegotiations from "../../components/ExchangeNegotiations";
import ExchangeOrders from "../../components/ExchangeOrders";

export default function Token(props) {
  const navigation = useNavigation();
  const [token, setToken] = useState({});
  const [heightPagerView, setHeightPagerView] = useState(350);
  const data = [30, 50, 40, 50, 40, 60];
  const screenWidth = Dimensions.get("window").width;
  const [valueIn, setValueIn] = useState(null);
  const [openIn, setOpenIn] = useState(false);
  const [balance, setBalance] = useState(0);
  const [dateGraphic, setDateGraphic] = useState(["1"]);
  const [dataGraphic, setDataGraphic] = useState([1]);
  const [lastQuote, setLastQuote] = useState("0.00");
  const [biggerQuote, setBiggerQuote] = useState("0.00");
  const [smallerQuote, setSmallerQuote] = useState("0.00");
  const [moviments, setMoviments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [volume, setVolume] = useState(0);
  const [qtd, setQtd] = useState(0);
  const [switchOrder, setSwitchOrder] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [toFixed, setToFixed] = useState(0);
  const [amountToken, setAmountToken] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [quotes, setQuotes] = useState([]);
  const [authorizationToken, setAuthorizationToken] = useState("");
  const [binancePrice, setBinancePrice] = useState();
  const [binanceOrderBookBid, setBinanceOrderBookBid] = useState();
  const [binanceOrderBookAsk, setBinanceOrderBookAsk] = useState();
  const [binanceTrades, setBinanceTrades] = useState();
  const [allOrders, setAllOrders] = useState([]);
  const isFocused = useIsFocused();
  const [customTokenValue, setCustomTokenValue] = useState(0);
  const [balanceGpx, setBalanceGpx] = useState(0);
  const [isBalanceSufficient, setIsBalanceSufficient] = useState(true);

  DropDownPicker.addTranslation("PT", {
    PLACEHOLDER: <FormattedMessage id="token.selelcione" />,
    NOTHING_TO_SHOW: <FormattedMessage id="token.nadaParaMostrar" />,
  });
  DropDownPicker.setLanguage("PT");

  useEffect(() => {
    const totalCost = qtd * parseFloat(getPlaceNewOrderValue());
    const hasEnoughBalance = balanceGpx >= totalCost;

    setIsBalanceSufficient(hasEnoughBalance);
  }, [qtd, balanceGpx]);

  const loadAuthorization = async () => {
    try {
      const authtoken = await AsyncStorage.getItem("JWT_TOKEN");
      if (authtoken) {
        setAuthorizationToken(authtoken);
        await loadAmountToken(authtoken);
      } else {
        console.error("Authorization token not found");
      }
    } catch (error) {
      console.error("Failed to load token:", error);
    }
  };

  useEffect(() => {
    loadAuthorization();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (authorizationToken && token.id) {
        if (["BTC", "ETH", "ADA"].includes(token.name_token)) {
          const pair = token.name_token + "BRL";

          try {
            // OrderBook
            const orderBookResponse = await axios.get(
              `https://api.binance.com/api/v3/depth?symbol=${pair}&limit=50`
            );
            setBinanceOrderBookBid(orderBookResponse.data?.bids || []);
            setBinanceOrderBookAsk(orderBookResponse.data?.asks || []);

            // Trades
            const tradesResponse = await axios.get(
              `https://api.binance.com/api/v3/trades?symbol=${pair}&limit=50`
            );
            setBinanceTrades(tradesResponse.data || []);
            setQuotes(tradesResponse.data.slice(0, 10));

            // Price
            const priceResponse = await axios.get(
              `https://api.binance.com/api/v3/ticker/price?symbol=${pair}`
            );
            if (priceResponse.data?.price) {
              setLastQuote(parseFloat(priceResponse.data.price) * 1.015);
            }

            getBinanceCandlestickData(pair);
          } catch (error) {
            console.error("Error fetching Binance data:", error);
          }
        } else {
          try {
            const response = await activesService.getLastQuotesByActiveId(
              authorizationToken,
              token.id
            );
            if (response.status === 200 && response.data.length > 0) {
              setLastQuote(parseFloat(response.data[0].price));
              setQuotes(response.data);
            }
          } catch (error) {
            console.error("Error fetching active quotes:", error);
          }

          getBalance();
          getExchangeDetails();
          getExchangeOrders();
        }
        setLoading1(false);
      }
    };

    /*  const interval = setInterval(() => {
      fetchData();
    }, 15000);

    return () => clearInterval(interval); */

    //changed for the structure bellow

    let isMounted = true;

    const fetchDataWithInterval = async () => {
      if (!isMounted || !isFocused) return;

      await fetchData();
      if (isMounted && isFocused) {
        setTimeout(fetchDataWithInterval, 15000);
      }
    };

    if (isFocused) {
      fetchDataWithInterval();
    }

    return () => {
      isMounted = false;
    };
  }, [authorizationToken, token]);

  useEffect(() => {
    const initialize = async () => {
      setLoading1(true);
      const jwt = await AsyncStorage.getItem("JWT_TOKEN");
      setAuthorizationToken(jwt);

      if (props.route.params.id) {
        const tokenData = await getTokenData(props.route.params.id);
        setToken(tokenData);
      } else {
        setToken((prevToken) => ({
          ...prevToken,
          id: props.route.params.id,
          name_token: props.route.params.name,
          path: props.route.params.path,
          single_value: props.route.params.single_value,
          cryptoactive: props.route.params.cryptoactive,
        }));
      }
    };
    setLoading1(false);
    initialize();
  }, [props.route.params]);

  useEffect(() => {
    if (quotes) {
      let newDateGraphic = [];
      let newDataGraphic = [];
      //let currentDate = new Date();
      for (let i = 0; i < Math.min(quotes.length, 6); i++) {
        if (
          token?.name_token &&
          ["BTC", "ETH", "ADA"].indexOf(token?.name_token) !== -1
        ) {
          let d = new Date(quotes[i].time);
          newDateGraphic.push(
              ("0" + d.getHours()).slice(-2) +
              ":" +
              ("0" + d.getMinutes()).slice(-2) +
              ":" +
              ("0" + d.getSeconds()).slice(-2)
          );
          newDataGraphic.push(parseFloat(quotes[i].price + ""));
        } else {
          newDateGraphic.unshift(quotes[i].label);
          newDataGraphic.unshift(parseFloat(quotes[i].price + ""));
        }
      }
      setDateGraphic(newDateGraphic);
      setDataGraphic(newDataGraphic);
    }
  }, [quotes]);

  useEffect(() => {
    if (binanceTrades && binanceTrades.length > 0) {
      let nMoviments = [];
      for (let i = 0; i < Math.min(binanceTrades.length, 6); i++) {
        nMoviments.push({
          quantity: binanceTrades[i].qty,
          value_coin: binanceTrades[i].price,
        });
      }
      setMoviments(nMoviments);
    }
  }, [binanceTrades]);

  /* useEffect(() => {
    if (isFocused) {
      if (props.route.params.id) {
        const td = getTokenData(props.route.params.id).then((td) => {
          setToken(td);
        });
      } else if (token.id) {
        setToken({
          id: props.route.params.id,
          name_token: props.route.params.name,
          path: props.route.params.path,
          single_value: props.route.params.single_value,
          cryptoactive: props.route.params.cryptoactive,
        });
      }
    }
  }, [isFocused]); */

  async function getTokenData(idToken) {
    const jwt = await AsyncStorage.getItem("JWT_TOKEN");

    const tData = await activesService.getById(jwt, idToken);
    const ativo = tData.data.actives[0];

    if (tData.data?.count) {
      setAmountToken(tData.data.count);
    }

    return {
      id: ativo.id,
      name_token: ativo.name_token,
      path: ativo.path,
      single_value: ativo.single_value,
      cryptoactive: ativo.cryptoactive,
    };
  }
  const loadAmountToken = async (token) => {
    try {
      if (!token) {
        console.error("Token is required to load amount");
        return;
      }

      const response = await activesService.getById(token, token.id);

      if (response.data?.count) {
        setAmountToken(response.data.count);
      }
    } catch (error) {
      console.error("Error in loadAmountToken:", error);
    }
  };

  const getExchangeDetails = async () => {
    try {
      const { data, status } = await exchangeService.getDetailsByToken(
        authorizationToken,
        token.id
      );

      if (status === 200) {
        if (data.ultima?.value_coin)
          setLastQuote(
            parseFloat(data.ultima.value_coin) / parseInt(data.ultima.quantity)
          );
        if (data.maior?.value_coin)
          setBiggerQuote(data.maior.value_coin / parseInt(data.maior.quantity));
        if (data.menor?.value_coin)
          setSmallerQuote(
            data.menor.value_coin / parseInt(data.menor.quantity)
          );

        // Converta os valores para o tipo esperado antes de definir
        if (data.negociacoes) {
          const adjustedMoviments = data.negociacoes.map((item) => ({
            ...item,
            quantity: Number(item.quantity),
            value_coin: Number(item.value_coin),
          }));
          setMoviments(adjustedMoviments);
        }

        if (data.volume["24h"]) setVolume(data.volume["24h"]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading1(false);
    }
  };

  // essa order que tem que valer
  const getExchangeOrders = async () => {
    setLoading2(true);
    setOrders([]);
    try {
      const { data } = await exchangeService.getOrdersByActive(
        authorizationToken,
        token.id
      );
      setOrders(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading2(false);
    }
  };

  const getBinanceExchangeOrders = async () => {
    setOrders([]);
    exchangeService
      .getOrders(authorizationToken, token.id)
      .then((response) => {
        setOrders(response.data);
      })
      .catch((error) => {});
  };

  const confirmCancelOrder = async (orderId) => {
    if (token && token.cryptoactive) {
      try {
        await exchangeService.cancelOrderBinance(authorizationToken, orderId);
      } catch ({ response }) {
        if (response?.data?.message) {
          toast(response?.data?.message, "#DA1414");
        } else {
          toast(intl.formatMessage({ id: "token.ocorreuUmErro" }), "#DA1414");
        }
      }
    } else {
      try {
        await exchangeService.cancelOrder(authorizationToken, orderId);
        await getExchangeOrders();
      } catch (error) {
        console.error(error);
      }
    }
  };
  const intl = useIntl();

  const cancelOrder = async (orderId, valueCoin) => {
    const value = formatGPXBalance(valueCoin);
    const tokenFrase = intl.formatMessage({ id: "token.cancelamentoDeOrdem" });
    const tokenInterrogacao = intl.formatMessage({ id: "token.?" });
    if (confirm(`${tokenFrase} ${value}${tokenInterrogacao}`)) {
      confirmCancelOrder(orderId);
    } else {
      return;
    }
  };

  const getBalance = async () => {
    setLoading3(true);
    try {
      const { data } = await balanceService.getBalanceOfToken(
        authorizationToken,
        token.id
      );

      const response = await balanceService.getBalanceOfGpx(authorizationToken);
      console.log("API Response:", response); // Debugging

      const balance = response?.data?.balance; // Ajuste aqui
      console.log("Balance Data:", balance); // Debugging

      if (Array.isArray(balance) && balance.length > 0) {
        const dataGpx = balance[0];
        setBalanceGpx(dataGpx.available_balance);
        console.log("balanceGpx", dataGpx.available_balance);
      } else {
        console.log("No balance data found.");
      }

      setBalance(data?.saldo + "");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading3(false);
    }
  };

  function selectedTimeGraphic(value) {}

  const getTokenName = () => {
    if (token?.name_token) {
      return token?.name_token;
    }
    return "";
  };

  const getTokenValue = () => {
    /* if (lastQuote && parseFloat(lastQuote + "") > 0) {
      return Math.min(parseFloat(token?.single_value), parseFloat(lastQuote));
    } */

    if (token?.single_value) {
      return parseFloat(token?.single_value);
    }
    return 0.0;
  };

  const getBinanceCandlestickData = (pair) => {
    axios
      .get(
        "https://api.binance.com/api/v3/klines?symbol=" +
          pair +
          "&interval=1d&limit=1"
      )
      .then((response) => {
        if (response?.data?.length > 0) {
          if (response.data[0][2])
            setBiggerQuote(parseFloat(response.data[0][2]) * 1.015);
          if (response.data[0][3])
            setSmallerQuote(parseFloat(response.data[0][3]) * 1.015);
          if (response.data[0][5]) setVolume(response.data[0][5] / 100);
        }
      });
  };

  const getPlaceNewOrderValue = () => {
    if (switchOrder) {
      let valCustom = customTokenValue + "";
      return parseFloat(
        valCustom.trim().length > 0 ? valCustom.trim() : token?.single_value
      );
    }

    return getTokenValue();
  };

  const BalanceInfo = () => <View style={styles.balance_info_container}></View>;

  const handleBuy = () => {
    let objParam = {
      qtd: qtd,
      token: token.id,
      viewType: "buy",
      customTokenValue: getPlaceNewOrderValue(),
      price: getPlaceNewOrderValue(),
    };
    if (token && !["BTC", "ETH", "ADA"].includes(token?.name_token)) {
      objParam = {
        qtd: qtd,
        token: token.id,
        viewType: "buy",
        market: true,
        customTokenValue: getPlaceNewOrderValue(),
        price: getPlaceNewOrderValue(),
      };
    }
    navigation.navigate("ConfirmPurchaseOrSell", objParam);
  };

  const handleSell = () => {
    let objParam = {
      qtd: qtd,
      token: token.id,
      viewType: "sell",
      customTokenValue: getPlaceNewOrderValue(),
      price: getPlaceNewOrderValue(),
    };

    if (token && !["BTC", "ETH", "ADA"].includes(token.name_token)) {
      objParam = {
        qtd: qtd,
        token: token.id,
        viewType: "sell",
        market: true,
        customTokenValue: getPlaceNewOrderValue(),
      };
    }
    navigation.navigate("ConfirmPurchaseOrSell", objParam);
  };

  const handleChangeValue = (value) => {
    setQtd(value);
  };
  const handleChangeCustomPrice = (value) => {
    /*  const formattedNumber = value
      .replace(",", ".")
      .replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2");
    */
    const formattedNumber = value
      .replace(/,/g, ".")
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*)\./g, "$1");
    setCustomTokenValue(parseFloat(formattedNumber) || "");
  };
  useEffect(() => {
    !switchOrder && setCustomTokenValue(0);
  }, [switchOrder]);

  useEffect(() => {
    const fetchOrders = async () => {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      const activeId = props.route.params.id;
      try {
        const response = await exchangeService.getAllOrders(token, activeId);
        setAllOrders(response.data);
      } catch (error) {
        console.error("Erro ao carregar as ordens:", error);
      } finally {
        setLoading1(false);
      }
    };

    fetchOrders();
  }, []);
  return (
    <View style={styles.container}>
      <ScreenLoader loading={loading1 || loading2 || loading3} />

      <HeaderTabs
        title={<FormattedMessage id="token.exchangeMaiuscula" />}
        subtitle={<FormattedMessage id="token.subtitulo" />}
      />

      <View style={styles.containerSecundario}>
        <View style={styles.containerTerceiroColumn}>
          {/* CARD */}
          <View style={styles.card}>
            <View style={styles.cardHeader}>
              <Text style={styles.cardHeaderValue}>{token.name_token}</Text>
              <Text style={styles.cardTitle}>
                <FormattedMessage id="token.valorAtual" />
              </Text>
              <Text style={styles.cardHeaderValue}>
                {formatGPXBalance(getTokenValue())}{" "}
                <FormattedMessage id="token.gpx/Brl" />
              </Text>
            </View>
            <View style={styles.hr} />
            <View style={styles.cardContent}>
              <View style={{ gap: 15 }}>
                <Text style={styles.cardTitle}>
                  <FormattedMessage id="token.meuSaldo" />
                </Text>
                <Text style={styles.cardValue}>
                  <If condition={token && !token.cryptoactive}>
                    <Then>{balance}</Then>
                    <Else>
                      {maxDecimals(balance, 8)} {getTokenName()}
                    </Else>
                  </If>
                </Text>

                <Text style={styles.cardValueGpx}>
                  <FormattedMessage id="token.gpx" />
                  {": "}
                  {formatGPXBalance(balance * getTokenValue())}
                </Text>
              </View>
              <View style={{ gap: 15, alignItems: "flex-end" }}>
                <When condition={token && !token.cryptoactive}>
                  <Text style={styles.cardTitle}>
                    <FormattedMessage id="token.quantidadeDisponivel" />
                  </Text>
                  <Text style={styles.cardValue}>
                    {amountToken} {getTokenName()}
                  </Text>
                </When>
              </View>
            </View>
            <View style={styles.hr} />

            <View style={styles.cardFooter}>
              <View>
                <Text style={[styles.cardTitle]}>
                  <FormattedMessage id="token.ultima" />
                </Text>
                <Text style={styles.cardValue}>
                  {/* {formatGPXBalance(getTokenValue())} */}
                  {lastQuote}
                  <FormattedMessage id="token.gpx" />
                </Text>

                <Text style={styles.cardTitle}>
                  <FormattedMessage id="token.menor" />
                </Text>
                <Text style={styles.cardValue}>
                  {smallerQuote && formatGPXBalance(smallerQuote)}
                  <FormattedMessage id="token.gpx" />
                </Text>

                <Text style={styles.cardTitle}>
                  <FormattedMessage id="token.maior" />
                </Text>
                <Text style={styles.cardValue}>
                  {biggerQuote && formatGPXBalance(biggerQuote)}
                  <FormattedMessage id="token.gpx" />
                </Text>
              </View>
              <View style={{ gap: 15, alignItems: "flex-end" }}>
                <Text style={styles.cardTitle}>
                  <FormattedMessage id="token.variacao" />
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={styles.cardValue}>
                    {smallerQuote &&
                      formatGPXBalance(
                        ((parseFloat(getTokenValue() + "") -
                          parseFloat(smallerQuote + "")) /
                          parseFloat(smallerQuote + "")) *
                          100
                      )}
                  </Text>
                  <Text>
                    <FormattedMessage id="token.%" />
                  </Text>
                </View>
                <Text style={styles.cardTitle}>
                  <FormattedMessage id="token.volume24H" />
                </Text>

                <Text style={styles.cardNameToken}>
                  {volume && formatGPXBalance(volume)} {getTokenName()}
                </Text>
              </View>
            </View>
            <View style={styles.hr} />
          </View>
          {/* FIM DO CARD */}

          {/* INÍCIO DO CARD COMPRAR */}
          <View style={styles.containerCardComprar}>
            <View style={{ paddingTop: 12 }}>
              <Text style={styles.cardHeaderValue}>
                <FormattedMessage id="token.headerEmitaOrdem" />
              </Text>
              <BalanceInfo />
              {/* <ActionButtons qtd={qtd} setQtd={(qtdParam) => setQtd(qtdParam)} switchOrder={switchOrder} setSwitchOrder={(setParam) => setSwitchOrder(setParam)} handleBuy={() => {handleBuy()}} handleSell={() => {handleSell()}}/> */}
              <If condition={token}>
                <Then>
                  <View style={[styles.switch]}>
                    <Text
                      style={[
                        switchOrder ? styles.textDisabled : styles.textEnabled,
                      ]}
                    >
                      <FormattedMessage id="token.ordemRapida" />
                    </Text>
                    <Switch
                      trackColor={"#ccc"}
                      thumbColor={"#2797A2"}
                      ios_backgroundColor="#3e3e3e"
                      onValueChange={setSwitchOrder}
                      value={switchOrder}
                      style={{ marginHorizontal: 20 }}
                    />
                    <Text
                      style={[
                        switchOrder ? styles.textEnabled : styles.textDisabled,
                      ]}
                    >
                      <FormattedMessage id="token.ordemLimitada" />
                    </Text>
                  </View>
                </Then>
                <Else>
                  <></>
                </Else>
              </If>

              <When condition={switchOrder}>
                <View style={styles.action_buttons_container}>
                  <Text style={{ marginBottom: 6 }}>
                    <FormattedMessage id="token.preco" />
                  </Text>

                  <NumberInput
                    value={customTokenValue}
                    step={0.01}
                    maxDecimalsParam={2}
                    onChange={(value) => handleChangeCustomPrice(value)}
                  />
                  <Text style={{ fontWeight: "bold", marginTop: 6 }}>
                    <FormattedMessage id="token.gpx/Brl" />
                  </Text>
                </View>
              </When>

              <View style={styles.contentPurchase}>
                <Text style={styles.titlePurchase}>
                  <FormattedMessage id="token.quantoDeseja" />
                </Text>
                <View style={styles.contentPurchaseAmount}>
                  <NumberInput
                    value={qtd}
                    maxDecimalsParam={toFixed}
                    onChange={(value) => handleChangeValue(value)}
                  />
                </View>
                <View style={{ alignItems: "center" }}>
                  <Text style={{ color: "#656565", paddingTop: 5 }}>
                    {formatGPXBalance(qtd * getPlaceNewOrderValue())}
                    <FormattedMessage id="token.gpx/Brl" />
                  </Text>
                </View>
              </View>
              <If condition={parseFloat(qtd * getPlaceNewOrderValue()) < 11}>
                <Then>
                  <View style={{ alignItems: "center" }}>
                    <Text style={styles.erroMinimo11}>
                      <FormattedMessage id="token.paraRealizarA" />
                    </Text>
                  </View>
                </Then>
                <Else>
                  <View style={[styles.action_buttons_container, { gap: 12 }]}>
                    {isBalanceSufficient}
                    <TouchableOpacity
                      disabled={!isBalanceSufficient}
                      style={[
                        styles.action_button,
                        styles.btnCompra,
                        {
                          backgroundColor: !isBalanceSufficient
                            ? "#889295"
                            : "#077A97",
                          borderColor: !isBalanceSufficient
                            ? "#889295"
                            : "#077A97",
                        },
                      ]}
                      onPress={() => {
                        handleBuy();
                      }}
                    >
                      <Text style={styles.actionButtonTxtComprar}>
                        <FormattedMessage id="token.comprar" />
                      </Text>
                    </TouchableOpacity>
                    <If
                      condition={
                        parseInt(balance) > 0 && parseInt(balance) >= qtd
                      }
                    >
                      <Then>
                        <TouchableOpacity
                          style={[styles.action_button, styles.btnVenda]}
                          onPress={() => {
                            handleSell();
                          }}
                        >
                          <Text style={styles.actionButtonVender}>
                            <FormattedMessage id="token.vender" />
                          </Text>
                        </TouchableOpacity>
                      </Then>
                      <Else>
                        <TouchableOpacity
                          style={[styles.action_button, styles.btnSemSaldo]}
                          disabled={true}
                        >
                          <Text style={styles.actionButtonTxtComprar}>
                            <FormattedMessage id="token.vender" />
                          </Text>
                        </TouchableOpacity>
                      </Else>
                    </If>
                  </View>
                </Else>
              </If>
              <If condition={parseInt(balance) > 0 && parseInt(balance) < qtd}>
                <Then>
                  <>
                    <Text style={styles.erroMinimo11}>
                      <FormattedMessage id="token.semSaldo" />
                    </Text>
                  </>
                </Then>
              </If>
              <If condition={!isBalanceSufficient}>
                <Then>
                  <>
                    <Text style={styles.erroMinimo11}>
                      <FormattedMessage id="token.msgSemSaldoGpx" />
                    </Text>
                  </>
                </Then>
              </If>
            </View>
          </View>

          <View />

          {/* FIM DO CARD COMPRAR */}
        </View>
        <View style={styles.containerGrafico}>
          {/* GRÁFICO Exchange */}
          <View key="0" style={{ width: 320 }}>
            {token?.id != undefined && ( // Verifica se token.id está presente
              <>
                <TradeView idCoin={token?.id} />
              </>
            )}
          </View>

          <View style={styles.containerNecociacoes}>
            <ExchangeOrders
              orders={orders}
              cancelOrder={cancelOrder}
              formatGPXBalance={formatGPXBalance}
            />

            <ExchangeNegotiations
              moviments={moviments}
              formatGPXBalance={formatGPXBalance}
            />

            <AllOrdersCard orders={allOrders} />
          </View>
        </View>
      </View>
    </View>
  );
}
